import { useSelector } from "react-redux"

export default () => useSelector(state => ({
  token: state.auth.token,
  orgId: state.organization.orgId,
  isMentor: state.auth.isMentor
}))
